import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import ClusterChart from '../../Chart/ClusterChart';
import {authContext} from '../../Context/Authentication/authContext';
import {baseURL} from '../../config';
import {generateBarChartData, DEMOGRAPHIC_LABELS} from '../../Helpers/helpers'


const Demographic = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [chartLabel, setChartLabel]: any = useState(DEMOGRAPHIC_LABELS.Age);

  useEffect(() => {
    getDemographics();
  }, [state.filters.demographicValue, state.filters.city]);

  const getDemographics = async () => {
    try {
      const APIEndpoint = `getDemographicDataBy${state.filters.demographicValue}`
      const response = await axios.get(
        `${baseURL}${APIEndpoint}?state=${state.filters.state}&city=${state.filters.city[0]}`
      );
      const resp = response.data?.list
      const data = generateBarChartData(resp);
      setChartData(data);
      // @ts-ignore
      setChartLabel(DEMOGRAPHIC_LABELS[state.filters.demographicValue])
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <>
          <div className='population-main__text'>Demographics</div>
          <ClusterChart
            chartData={chartData}
            info={chartLabel}
            disableEnable
          />
        </>
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default React.memo(Demographic);
